import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export interface SponsorLinksProps {
  children: ReactNode;
  className?: string;
}

export const SponsorLinks = ({ children, className }: SponsorLinksProps) => {
  return (
    <div
      className={twMerge(
        'flex w-full flex-row flex-wrap justify-between gap-1.5 lg:px-2',
        className,
      )}
    >
      {children}
    </div>
  );
};
